/** Default inspector width matching the previous fixed layout. */
export const INSPECTOR_DEFAULT_WIDTH_PX = 446;

/** Minimum usable width — panel stays readable (empty state, headers, badges). */
export const INSPECTOR_MIN_WIDTH_PX = 320;

/** Maximum width so the main workspace list remains usable. */
export const INSPECTOR_MAX_WIDTH_PX = 720;

/**
 * Clamps an inspector panel width to the allowed range.
 * Non-finite values fall back to the default width.
 */
export function clampInspectorWidth(width: number): number {
  if (!Number.isFinite(width)) {
    return INSPECTOR_DEFAULT_WIDTH_PX;
  }
  return Math.min(
    INSPECTOR_MAX_WIDTH_PX,
    Math.max(INSPECTOR_MIN_WIDTH_PX, Math.round(width)),
  );
}
